<template>
    <!-- Navbar -->
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <div class="container-fluid">
       
          <a class="navbar-brand" href="#">
            <router-link to='/Home'><img src="@/assets/img/logo-preta-120.png" height="" alt="" loading="lazy"/></router-link>
          </a>
        
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
          <!-- Links navbar -->
          <ul class="navbar-nav me-auto mb-2 mb-lg-0 nav-menu" style="margin-top: 8px">
                <router-link to='/Home'><li class="nav-item"> <a class="nav-link"><h5>Área do vistoriador</h5></a></li></router-link>            
                <router-link to='/Listagem-periodo'><li class="nav-item"><a class="nav-link" href="#">Localizar por período</a></li></router-link>
                <a href="https://ajuda.vexsoft.com.br/" target="_blank"><li class="nav-item nav-link">Base de conhecimento</li></a>
          </ul>
          
          <!-- Token display area -->
          <div style="margin-right: 10px; color: grey">
              <b>{{token}}</b>
          </div>

          <!--AVATAR-->
          <div class="d-flex">
            <div class="d-flex align-items-center">
              <a
                class="dropdown-toggle d-flex align-items-center hidden-arrow" href="#" id="navbarDropdownMenuLink" role="button" data-mdb-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown">
                <img :src="logoEmpresa" height="35" alt="Logo" loading="lazy"/>
              </a>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdownMenuLink" style="margin-right: 10px;">
                <li style="text-align: center;">
                  <h6>Olá, {{userName}}!<br>{{email}}</h6>
                </li>
                <li style="text-align: center; padding-left: 15px; padding-right: 15px; padding-bottom: 10px;">
                  <router-link to='/Dados-pessoais'><li><a href="#">Atualizar Dados Pessoais</a></li></router-link>
                </li>
                
                <li style="text-align: center">
                  <router-link to='/Login'>
                    <a class="link-danger" href="#" style="text-decoration: none" v-on:click="logout()">Sair</a>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div> <!-- collapse end -->
      </div> <!-- container end -->
    </nav> <!-- Navbar end -->
    <router-view/>    
    
</template>

<script>
export default {
    name: 'Navbar',
    data() {
      return {
        userName: localStorage.getItem('nomeUsuario'),
        token: localStorage.getItem('token'),
        email: localStorage.getItem('email'),
        logoEmpresa : "https://files.vexsoft.com.br/" + localStorage.getItem('token') + "/logo.png" 
      }
    },
    methods:{
        logout(){
            localStorage.removeItem('token')
            localStorage.removeItem('email')
            localStorage.removeItem('nomeUsuario')
            localStorage.removeItem('idUsuario')
            localStorage.removeItem('celular')
            localStorage.removeItem('sexo')
            localStorage.removeItem('data_nascimento')
            localStorage.removeItem('ultima_atualizacao')
            localStorage.removeItem('mostrarMensagem')
            sessionStorage.removeItem('tempDataNascimento')
            sessionStorage.removeItem('tempCelular')
      },
    }
}
</script>

<style>

  .navbar-brand{
    margin-left: 15px;
  }

  a{
    text-decoration: none;
    color: inherit;
  }

  .titulo-custom{
    font-size: 16pt;
  }


</style>